import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { CurrentOrg } from '@efficiently/client-api-org-context';

import { DefaultCurrentOrg } from './default-current-org.service';

/**
 * Binds {@link CurrentOrg} to {@link DefaultCurrentOrg}. Use in apps that
 * produce the org id from their own init flow (e.g. design-schedule sets it
 * from `AppInitService` after the user/scope config is loaded).
 *
 * For apps that need the hostname-based bootstrap (client-portal), use
 * `provideCurrentOrgBootstrap` instead — it includes this binding plus the
 * initializer.
 */
export function provideCurrentOrg(): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: CurrentOrg, useExisting: DefaultCurrentOrg }]);
}
